import JoyrideMain from './JoyrideMain'

export default JoyrideMain